

const warehousehomePage = require('./warehousehome-page')



export function start(detail){  // console.log('goku-dt 5>', detail)
         
      obj[detail.elem].start(detail)

}/**/




const obj = {
   

      page:            { start: (detail)=>{  warehousehomePage.start(detail)             }},


}








